exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.footer{position:fixed;bottom:0;height:56px;margin:0 auto;width:100%;overflow:visible;background-color:#fff;z-index:18}.footer hr{position:absolute;left:0;top:0;height:1px;margin:0;border:none;border-bottom:1px solid #ddd;width:100%;z-index:17}.footer .footer-container{position:absolute;top:13px;left:0;width:calc(100% - 100px);display:flex;text-align:center;height:35px;margin:0 37px}.footer .footer-container .vendor-logo{position:absolute;left:0;height:27px;width:24px;top:4px}.footer .footer-container .footer-text{font-size:10px;font-family:Open Sans,sans-serif;font-weight:400;color:#353535;margin:auto;margin-top:12px;line-height:11px}.footer .footer-container .link-container{position:absolute;top:0;right:0;display:flex;flex-direction:row-reverse;color:#bababa}.footer .footer-container .link-container span{margin-top:8px}.footer .footer-container .link-container .link{margin:12px 0;font-family:Open Sans,sans-serif;font-weight:400;color:#bababa;cursor:pointer}.footer .footer-container .link-container .link:hover{color:#8b8b8b}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/Footer/Footer.scss
// module id = 1564
// module chunks = 0